import { api } from "./client";

export interface DeviceSummary {
  id: string;
  serial_number: string;
  model: string;
  label: string | null;
  registered_version: string | null;
  target_version: string | null;
  last_seen_at: string | null;
  is_online: boolean;
}

export interface HeartbeatSnapshot {
  id: number;
  received_at: string;
  captured_at: string | null;
  firmware_version: string | null;
  latitude: number | null;
  longitude: number | null;
  power_consumption_w: number | null;
  battery_percent: number | null;
  on_external_power: boolean | null;
  stats: Record<string, unknown>;
}

export interface DeviceDetail {
  id: string;
  serial_number: string;
  model: string;
  label: string | null;
  is_active: boolean;
  is_setup: boolean;
  static_latitude: number | null;
  static_longitude: number | null;
  target_version: string | null;
  registered_version: string | null;
  consumables: Record<string, unknown> | null;
  config: Record<string, unknown>;
  commission_date: string | null;
  decommission_date: string | null;
  warranty_date: string | null;
  created_at: string;
  last_seen_at: string | null;
  is_online: boolean;
  latest_heartbeat: HeartbeatSnapshot | null;
}

export interface ErrorLogEntry {
  id: number;
  received_at: string;
  captured_at: string | null;
  code: number;
  message: string;
  context: string | null;
  metadata: Record<string, unknown>;
}

export interface ActivityLogEntry {
  id: number;
  received_at: string;
  captured_at: string | null;
  code: number;
  message: string;
  metadata: Record<string, unknown>;
}

export interface FirmwareUpdateEntry {
  id: number;
  reported_at: string;
  old_version: string | null;
  new_version: string;
  success: boolean;
  metadata: Record<string, unknown>;
}

export interface CalibrationEntry {
  id: number;
  executed_at: string;
  is_active: boolean;
  water: (number | null)[];
  paper: (number | null)[];
}

export const devicesApi = {
  list: () =>
    api.get<{ devices: DeviceSummary[] }>("/api/dashboard/devices"),
  detail: (id: string) =>
    api.get<DeviceDetail>(`/api/dashboard/devices/${id}`),
  heartbeats: (id: string, limit = 25) =>
    api.get<{ heartbeats: HeartbeatSnapshot[] }>(
      `/api/dashboard/devices/${id}/heartbeats?limit=${limit}`,
    ),
  errorLogs: (id: string, limit = 50) =>
    api.get<{ errors: ErrorLogEntry[] }>(
      `/api/dashboard/devices/${id}/error-logs?limit=${limit}`,
    ),
  activityLogs: (id: string, limit = 50) =>
    api.get<{ activity: ActivityLogEntry[] }>(
      `/api/dashboard/devices/${id}/activity-logs?limit=${limit}`,
    ),
  firmwareUpdates: (id: string, limit = 50) =>
    api.get<{ updates: FirmwareUpdateEntry[] }>(
      `/api/dashboard/devices/${id}/firmware-updates?limit=${limit}`,
    ),
  calibrations: (id: string, limit = 50) =>
    api.get<{ calibrations: CalibrationEntry[] }>(
      `/api/dashboard/devices/${id}/calibrations?limit=${limit}`,
    ),
};
